import { FilterField } from "layout/TableConstructor/types";
import { InputType } from "components/generators/inputsGenerator";
import VALIDATION from "helpers/validation";
import { VacancyCompanyCandidateFilter } from "pages/Vacancies/view/types";

const filterConfig: FilterField<VacancyCompanyCandidateFilter>[] = [
  {
    name: "numericId",
    label: "ID кандидата",
    type: InputType.TEXT,
    inputType: "number",
  },
  {
    name: "createdAt",
    label: "Дата создания",
    type: InputType.DATE,
  },
  {
    name: "telegramUsername",
    label: "Ник Telegram",
    type: InputType.TEXT,
    rules: VALIDATION.telegramUsername,
    additionalFilter: {
      isTelegram: true,
    },
  },
  {
    name: "login",
    label: "Логин",
    type: InputType.TEXT,
    additionalFilter: {
      isTelegram: false,
    },
  },
  {
    name: "fullName",
    label: "ФИО кандидата",
    type: InputType.TEXT,
  },
  {
    name: "isCVFile",
    label: "Файл резюме",
    type: InputType.AUTOCOMPLETE,
    options: [
      { id: "true", displayName: "Да" },
      { id: "false", displayName: "Нет" },
    ],
    customFilter: (value) => value.id === "true",
  },
  {
    name: "cvCheckScore",
    label: "Соответствие вакансии",
    type: InputType.TEXT,
    inputType: "number",
    isRange: true,
  },
  {
    name: "totalExperienceYears",
    label: "Стаж",
    type: InputType.TEXT,
    inputType: "number",
    isRange: true,
  },
  {
    name: "criterionMatch_experience",
    label: "Опыт",
    type: InputType.TEXT,
    inputType: "number",
    arrayItemParams: {
      parentFilterName: "criterionMatch",
      name: { key: "criteria", value: "Опыт" },
      value: { key: "score" },
    },
    isRange: true,
  },
  {
    name: "criterionMatch_relevance",
    label: "Релевантность",
    type: InputType.TEXT,
    inputType: "number",
    arrayItemParams: {
      parentFilterName: "criterionMatch",
      name: { key: "criteria", value: "Релевантность" },
      value: { key: "score" },
    },
    isRange: true,
  },
  {
    name: "criterionMatch_skills",
    label: "Навыки и сертификаты",
    type: InputType.TEXT,
    inputType: "number",
    arrayItemParams: {
      parentFilterName: "criterionMatch",
      name: { key: "criteria", value: "Навыки и сертификаты" },
      value: { key: "score" },
    },
    isRange: true,
  },
  {
    name: "criterionMatch_resume",
    label: "Оформление резюме",
    type: InputType.TEXT,
    inputType: "number",
    arrayItemParams: {
      parentFilterName: "criterionMatch",
      name: { key: "criteria", value: "Оформление резюме" },
      value: { key: "score" },
    },
    isRange: true,
  },
  {
    name: "criterionMatch_projects",
    label: "Проекты и достижения",
    type: InputType.TEXT,
    inputType: "number",
    arrayItemParams: {
      parentFilterName: "criterionMatch",
      name: { key: "criteria", value: "Проекты и достижения" },
      value: { key: "score" },
    },
    isRange: true,
  },
  {
    name: "criterionMatch_soft_skills",
    label: "Софт-скиллы",
    type: InputType.TEXT,
    inputType: "number",
    arrayItemParams: {
      parentFilterName: "criterionMatch",
      name: { key: "criteria", value: "Софт-скиллы" },
      value: { key: "score" },
    },
    isRange: true,
  },
  {
    name: "recommendations",
    label: "Комментарии по опыту",
    type: InputType.TEXT,
  },
  {
    name: "advanatges",
    label: "Ключевые плюсы кандидата",
    type: InputType.TEXT,
  },
  {
    name: "disadvantages",
    label: "Ключевые минусы кандидата",
    type: InputType.TEXT,
  },
];

export default filterConfig;
